// src/pages/WishlistPage.js
import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { LanguageContext } from "../context/LanguageContext";
import { getProductById } from "../data/products";
import AddToCartSelectorDrawer from "../components/AddToCartSelectorDrawer";
import AddedToBagToast from "../components/AddedToBagToast";
import { getMyWishlist } from "../services/wishlist.api";

function WishlistPage() {
  const { wishlist, toggleWishlist, addToCart } = useCart();
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  
  const [selectorOpen, setSelectorOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);

  const TEXT = {
    EN: {
      title: "YOUR WISHLIST",
      empty: "Your wishlist is empty.",
      addToCart: "Add to Cart",
      remove: "Remove",
      startShopping: "Start Shopping",
    },
    AR: {
      title: "المفضلة",
      empty: "قائمة المفضلة فارغة.",
      addToCart: "أضيفي إلى السلة",
      remove: "إزالة",
      startShopping: "ابدئي التسوق",
    },
  };

  const t = TEXT[lang];

    const handleAddToCartClick = (item) => {
    // Try to find full product (with sizes/colors) by id
    const fullProduct = getProductById(item.id);

    if (!fullProduct) {
      // Fallback: if not found for some reason, just add directly
      addToCart(item);
      return;
    }

    setSelectedProduct(fullProduct);
    setSelectedSize(null);
    setSelectedColor(null);
    setSelectorOpen(true);
  };

   useEffect(() => {
  const token = localStorage.getItem("esill-token");
  if (!token) return;

  const loadWishlist = async () => {
    try {
      const data = await getMyWishlist();
      // directly update context wishlist
      toggleWishlist({ __sync: true, items: data });
    } catch (err) {
      console.error("Failed to sync wishlist", err);
    }
  };

  loadWishlist();
}, []);

  return (
    <>
      {/* Toast (same as ProductsPage) */}
      <AddedToBagToast />

    <div
      className="w-full min-h-screen bg-white pt-[95px] px-4 pb-24"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      {/* BACK BUTTON */}
      <button
        onClick={() => navigate(-1)}
        className="absolute top-[80px] left-4 text-3xl opacity-60 hover:opacity-100"
      >
        ×
      </button>

      {/* TITLE */}
      <h1 className="text-xl font-semibold text-center">{t.title}</h1>
      <div className="h-[2px] w-16 bg-black mt-2 mb-6 mx-auto"></div>

      {/* EMPTY STATE */}
            {wishlist.length === 0 && (
        <div className="flex flex-col items-center mt-20">
          <img src="/icons/heart.png" className="w-12 opacity-40 mb-4" />
          <p className="text-sm opacity-70">{t.empty}</p>

          <button
            onClick={() => navigate("/")}
            className="
              mt-4 px-5 py-2
              rounded-full bg-black text-white
              text-sm font-semibold
              hover:bg-[#222] transition
            "
          >
            {t.startShopping}
          </button>
        </div>
      )}


      {/* GRID */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {wishlist.map((item) => (
          <div
            key={item.id}
            className="border rounded-lg shadow-sm hover:shadow-md transition"
          >
            <img
              src={item.image}
              className="w-full h-40 object-cover rounded-t-lg"
              alt={lang === "EN" ? item.nameEN : item.nameAR}
            />

            <div className="p-3">
              <p className="font-semibold">
                {lang === "EN" ? item.nameEN : item.nameAR}
              </p>

              <p className="font-bold mt-1">${item.price}</p>

              {/* BUTTONS */}
              <div className="flex flex-col gap-2 mt-3">
                                <button
                  onClick={() => handleAddToCartClick(item)}
                  className="bg-black text-white py-2 rounded-md text-sm hover:bg-[#222] transition"
                >
                  {t.addToCart}
                </button>
                
                <button
                  onClick={() => toggleWishlist(item)}
                  className="border py-2 rounded-md text-sm hover:bg-[#F7F3F1] transition"
                >
                  {t.remove}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>

      {/* Size/Color selector drawer – same behavior as ProductsPage */}
      <AddToCartSelectorDrawer
        isOpen={selectorOpen}
        onClose={() => setSelectorOpen(false)}
        product={selectedProduct}
        selectedSize={selectedSize}
        selectedColor={selectedColor}
        setSelectedSize={setSelectedSize}
        setSelectedColor={setSelectedColor}
      />
    </>
  );
}


export default WishlistPage;
